import React from "react"

import {FieldGlistGroupProps} from "../../../../render/glist/glist-group"
import UserIcon from "../../../../../gd-ui/icon/user/user"

export default function FieldUser_GlistGroupStandard(props:FieldGlistGroupProps) {

    // Notice: value may be 'null' (string) because while grouping null value is automatically converted to string

    const value = props.data.value

    const groupName = _.get(props.field._getOption(value),'label', props.field.noValueOptionLabel)

    const user = gd.session.users.get(value)

    return (
        <div className="group-cards">
            {user && <UserIcon className="m-r-10 flex" size="22" userId={user.id}/>}
            <div className="text">{groupName}</div>
            {!!props.data.isCollapsed && <div className="counter">{props.data.counter}</div>}

            {!props.data.isCollapsed &&
                <div className="group-corners">
                    <div className="top-corner"/>
                </div>}
        </div>
    )


}
